import { withInstall } from '@ll-plus/utils'

import SelectGroup from './src/select-group.vue'

export const LlSelectGroup = withInstall(SelectGroup)
export default LlSelectGroup
export * from './src/select-group'

// 把ZIcon组件类型合并带全局组件中 到时候使用时有提示
declare module 'vue' {
  export interface GlobalComponents {
    LlSelectGroup: typeof SelectGroup
  }
}
